export default "__VITE_ASSET__d9f050bb__"